import { getVaultLockTime, } from "@bracket/parlance";
import type { ILockableVault, Vault, } from "@bracket/types";
import { bracketRate, latestPriceEth, } from "@cachables";
import { DateTime, } from "luxon";



/** obtain the next datetime where a vault requires NAV update and will be locked from usage until one is provided */
export const lock_date = ( vault: ILockableVault, ): DateTime => {
	// console.warn("\t\t ---- store/commons.ts: lock_date() called - use @bracket/parlance methods instead ----");
	const { epoch, } = vault;
	return getVaultLockTime({ vault, epoch, local: true, });
}

export const unlock_time = ( vault: ILockableVault, ): DateTime => {
	// console.warn("\t\t ---- store/commons.ts: unlock_time() called - use @bracket/parlance methods instead ----");
	return lock_date(vault).plus({ hours: vault.expected_lock_hours, });
}

/**
 * Calculates the expected epoch number for a vault based on the current chain time.
 * 
 * This function determines which epoch a vault should be in by calculating the time
 * difference between the vault's launch date and the provided chain timestamp.
 * 
 * @param {Vault} vault - The vault object containing launch date and epoch duration information
 * @param {number} chainTime - The current blockchain timestamp in milliseconds
 * @returns {number} The expected epoch number (0 if calculation fails)
 */
export const expected_epoch = ( vault: Vault, chainTime: number, ): number => {
	// console.warn("\t\t ---- store/commons.ts: expected_epoch() called - use @bracket/parlance methods instead ----");
	const {
		epoch_duration_days,
		epoch_offset_hours,
		launch_date,
	} = vault;

	const launch = DateTime.fromISO(launch_date);
	const now = DateTime.fromMillis(chainTime);
	const diff = now.diff(launch.plus({ minute: epoch_offset_hours * 60, }), "seconds");

	if(isDiffWithSeconds(diff)) {
		const epoch = Math.ceil(diff.values.seconds/(epoch_duration_days * 24 * 60 * 60));
		return epoch < 0 ? 0 : epoch;
	}

	return 0;

}


// TODO: caching mechanism
export const bracket_rate = async ():Promise<number> => {
	// console.warn("\t\t ---- store/commons.ts: bracket_rate() called - use @bracket/cachables methods instead ----");
	const rate = await bracketRate();
	if(typeof rate === "number") {
		return rate;
	}
	throw new Error("failed obtaining bracket rate");
}


// TODO: caching mechanism
export const eth_price = async ():Promise<number> => {
	// console.warn("\t\t ---- store/commons.ts: eth_price() called - use @bracket/cachables methods instead ----");
	const price = await latestPriceEth();
	if(typeof price === "number") {
		return price;
	}
	throw new Error("failed obtaining bracket rate");
}


export const brktToUsd = async ( value: bigint ):Promise<number> => {
	// console.warn("\t\t ---- store/commons.ts: brktToUsd() called - use @bracket/cachables methods instead ----");
	const [
		price,
		rate,
	]= await Promise.all([
		eth_price(),
		bracket_rate(),
	]);
	return (Number(value) / 1e18) * price * rate ;
}


export const usdToBrkt = async ( value: number ):Promise<bigint> => {
	// console.warn("\t\t ---- store/commons.ts: usdToBrkt() called - use @bracket/cachables methods instead ----");
	const [
		price,
		rate,
	]= await Promise.all([
		eth_price(),
		bracket_rate(),
	]);
	return BigInt(Math.floor(value / (price * rate) * 1e18));
}


const isDiffWithSeconds = ( diff: unknown, ): diff is { values: { seconds: number; } } => {
	if(typeof diff === "object" && !Array.isArray(diff) && diff !== null)	 {
		if("values" in diff) {
			if(typeof diff.values === "object" && !Array.isArray(diff.values) && diff.values !== null) {
				if("seconds" in diff.values) {
					return true;
				}
			}
		}
	}
	return false;
}
